import React, { useState } from 'react';
import "./form.css";
import emailjs from '@emailjs/browser';

export default function Appoinment() {
  const [data, setData] = useState({
    name: '',
    number: '',
    mail: '',
    service: '',
    industry: '',
    message: '',
  });

  const { name, mail, message, number, service, industry } = data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('service_2ngpwpb', 'template_vtill0y', e.target, {
        publicKey: '7EMaxiQ-EAWBo9lQD',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          alert('Thank you for your email. We will get back to you shortly.');
          setData({
            name: '',
            number: '',
            mail: '',
            service: '',
            industry: '',
            message: '',
          });
        },
        (error) => {
          console.log('FAILED...', error.text);
        }
      );
    e.target.reset();
  };

  return (
    <div className='contactus'>
      <h2 style={{ textAlign: "center" }}>Contact us</h2>

      {/* Image container */}
      <div className='cnt1'>
        <img src="./img1.jpg" alt="" className='img1' />
      </div>

      {/* Contact us address */}
      <div className='cnt2'>
        <h3>Contact us</h3>
        <p className='heading'>Corporate Office</p>
        <b>New Horizons Cybersoft Limited</b>
        <br />
        <p>#H No. 8-2-624/1, 3rd Floor 2, Avenue 4,</p>
        <p>Road No. 10, Opposite City Central Mall, Banjara Hills,</p>
        <p>Hyderabad, INDIA - 500034.</p>
        <p>+91-9397306732</p>
        <br />
      </div>

      {/* Form and contact info */}
      <div className='cnt3'>
        <div className='leftside'>
          <form onSubmit={handleSubmit} className='forms'>
            <h3>Send Message</h3>

            <input
              value={name}
              name='name'
              onChange={handleChange}
              className='inputs'
              type='text'
              placeholder='Your Name'
              required
            />

            <p>Mobile Number</p>
            <input
              value={number}
              name='number'
              onChange={handleChange}
              className='inputs'
              type='number'
              placeholder='Mobile number'
              required
            />

            <p>Email Address</p>
            <input
              value={mail}
              name='mail'
              onChange={handleChange}
              className='inputs'
              type='email'
              placeholder='Your Email'
              required
            />

            <p>Service Type</p>
            <select
              className='inputs'
              id='service'
              name='service'
              value={service}
              onChange={handleChange}
              required
            >
              <option value="">Select Service Type</option>
              <option value="SAP Business One">SAP Business One</option>
              <option value="SAP All in One">SAP All in One</option>
              <option value="Odoo Solution">Odoo Solution</option>
              <option value="TRM Billing">TRM Billing</option>
              <option value="E Commerce">E Commerce</option>
              <option value="Web Design & Development">Web Design & Development</option>
              <option value="Master Health">Master Health</option>
              <option value="Accounting Services">Accounting Services</option>
            </select>

            <p>Industry</p>
            <select
              className='inputs'
              id='industry'
              name='industry'
              value={industry}
              onChange={handleChange}
              required
            >
              <option value="">Select Industry</option>
              <option value="Chemicals">Chemicals</option>
              <option value="Telecommunications">Telecommunications</option>
              <option value="Construction">Construction</option>
              <option value="Consulting">Consulting</option>
              <option value="Electronics">Electronics</option>
              <option value="Engineering">Engineering</option>
              <option value="Finance">Finance</option>
              <option value="Food & Beverage">Food & Beverage</option>
              <option value="Government">Government</option>
              <option value="Healthcare">Healthcare</option>
              <option value="Hospitality">Hospitality</option>
              <option value="Manufacturing">Manufacturing</option>
              <option value="Retail">Retail</option>
              <option value="IT">IT</option>
              <option value="Logistics">Logistics</option>
              <option value="Utilities">Utilities</option>
              <option value="Education">Education</option>
              <option value="Pharma">Pharma</option>
              <option value="Automobile">Automobile</option>
              <option value="eCommerce">eCommerce</option>
            </select>

            <p>Leave us a Message</p>
            <textarea
              value={message}
              name='message'
              onChange={handleChange}
              className='textarea'
              placeholder='Your Message'
              required
            />

            <br />
            <button className='book'>Send Message</button>
          </form>
        </div>

        {/* Contact info right side */}
        <div className='rightside'>
          <h3>Contact Info</h3>
          <b>SAP Business One & ODOO - Sales</b><br /><br />
          <b>Haroon Rasheed</b><br /><br />
          <b>+91-9397306732</b>
          <p>Vice President - SAP</p>
          <p>haroon@nhclindia.com</p>
          <b>TRM - Sales</b><br /><br />
          <b>K.K. Ranga Chari</b><br /><br />
          <b>+91-9949023621</b>
          <p>Vice President – Operations</p>
          <p>kkrchari@rediffmail.com</p>
        </div>
      </div>

      <div>
        <h2 style={{ textAlign: "center" }}>Contact Address</h2>
      </div>

      {/* Location Map */}
      <div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.94181222808!2d78.44684147385279!3d17.414579883477256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb97341723598d%3A0xbb768824283cfd25!2sNew%20Horizons%20Cybersoft%20Ltd!5e0!3m2!1sen!2sin!4v1761127922388!5m2!1sen!2sin"
          width="100%"
          height="400px"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="company map"
        ></iframe>
      </div>
    </div>
  );
}
